import {StoreItemCategory, StoreMapType} from '../../entity_datas/StoreEnums.ts'
import {type TranslationObject, type TranslationArrayKeys} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {BaseStoreItem} from '../BaseStoreItem.ts'

export class SIMapEarth extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Earth
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.earth.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.earth.description'
    price = 500
    image = LobbyImage.MapEarthPreview
    activeInStore = true
}

export class SIMapUSA extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.USA
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.usa.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.usa.description'
    price = 500
    image = LobbyImage.MapUSAPreview
    activeInStore = true
}

export class SIMapUK extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.UK
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.uk.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.uk.description'
    price = 500
    image = LobbyImage.MapUKPreview
    activeInStore = true
}

export class SIMapDiamond extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Diamond
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.diamond.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.diamond.description'
    price = 500
    image = LobbyImage.MapDiamondPreview
    activeInStore = true
}

export class SIMapGear extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Gear
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.gear.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.gear.description'
    price = 500
    image = LobbyImage.MapGearPreview
    activeInStore = true
}

export class SIMapLakes extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Lakes
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.lakes.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.lakes.description'
    price = 500
    image = LobbyImage.MapLakesPreview
    activeInStore = true
}

export class SIMapPond extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Pond
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.pond.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.pond.description'
    price = 500
    image = LobbyImage.MapPondPreview
    activeInStore = true
}

export class SIMapTwirl extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Twirl
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.twirl.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.twirl.description'
    price = 500
    image = LobbyImage.MapTwirlPreview
    activeInStore = true
}

export class SIMapRandomBase extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Classic4PRandom
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.random4P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.classic.random4P.description'
    price = 500
    image = LobbyImage.MapRandomBasePreview
    activeInStore = true
}

export class SIMapShuffleBoard extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.ShuffleBoard
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.shuffleBoard.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.shuffleBoard.description'
    price = 500
    image = LobbyImage.MapShuffleBoardPreview
    activeInStore = true
}

export class SIMapBlackForest extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.BlackForest
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.blackForest.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.blackForest.description'
    price = 500
    image = LobbyImage.MapBlackForestPreview
    activeInStore = true
}

export class SIMapVolcano extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.Volcano
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.volcano.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.volcano.description'
    price = 500
    image = LobbyImage.MapVolcanoPreview
    activeInStore = true
}

export class SIMapGoldRush extends BaseStoreItem {
    category = StoreItemCategory.Map
    type = StoreMapType.GoldRush
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.goldRush.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameMaps.fun.goldRush.description'
    price = 500
    image = LobbyImage.MapGoldRushPreview
    activeInStore = true
}
